<template>
    <div class="px-1 sm:px-2 xl:px-5 quiz-item block relative">
        <div class="relative overflow-hidden border-ui-style bg-cover bg-center bg-norepeat">
            <div
                @click="useEmitClick ? onClickQuiz($event, url) : onLiveClickQuiz(url)"
                class="text-white no-underline cursor-pointer"
            >
                <div
                    :style="{ 'background-image': 'url(' + imagePath + ')', 'padding-top': '97%' }"
                    class="relative overflow-hidden bg-cover bg-center bg-norepeat"
                ></div>
                <div class="absolute title text-center">
                    <h4
                        class="text-white my-0 text-xs sm:text-sm md:text-lg uppercase font-opensans w-full"
                        v-html="title"
                    ></h4>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UserService from '@/lib/user.js'

export default {
    props: {
        title: {
            type: String,
            default: 'Coming soon'
        },

        image: {
            type: String,
            default: ''
        },

        id: {
            type: String
        },

        url: {
            type: String,
            default: '/'
        },

        useEmitClick: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        imagePath() {
            return !this.image || !this.image.length ? require('../assets/no-image.jpg') : this.image
        }
    },

    methods: {
        onClickQuiz(e, url) {
            this.$emit('click', e, url)
        },

        onLiveClickQuiz(url) {
            const userService = new UserService()

            if (!userService.getUser()) {
                this.$router.push({
                    name: 'login',
                    query: {
                        live: true,
                        path: btoa(url)
                    }
                })
            } else {
                location.href = url
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.quiz-item .title {
    left: 0;
    bottom: 0;
    background-image: linear-gradient(to top, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 100%);
    width: 100%;
    padding: 0.5rem;
    min-height: 25%;
    display: flex;
    align-items: flex-end;
    text-align: center;
}
</style>
